import React from "react";
import { MainHeader, PageLayout } from "shared";
import { FrequentlyQuestions } from ".";

export const Faq = () => {
  return (
    <>
      <MainHeader />
      <PageLayout breadcrumb={[{ label: "Frequently Asked Questions" }]}>
        <FrequentlyQuestions />
      </PageLayout>
    </>
  );
};
